<ng-container *ngIf="document.localization$ | async as localization">
	<div class="md:flex-none md:w-6"></div>
	<div
		*ngIf="controller.showTypeColumn$ | async"
		class="md:flex-1 flex justify-between"
	>
		<div class="md:hidden self-center whitespace-pre-line">
			{{ controller.i18n + '.types.text' | translate }}
		</div>
		<i
			[class]="document?.cssIconClass"
			class="md:text-xl text-base p-color-primary"
		></i>
	</div>
	<div class="md:flex-1 flex justify-between truncate">
		<div class="md:hidden whitespace-pre-line">
			{{ controller.i18n + '.name.text' | translate }}
		</div>
		{{ localization.name }}
	</div>
	<div
		*ngIf="controller.showSectionColumn$ | async"
		class="md:flex-1 flex justify-between"
	>
		<ng-container *ngIf="document.section$ | async as section">
			<div class="md:hidden whitespace-pre-line">
				{{ controller.i18n + '.sections.text' | translate }}
			</div>
			{{ (section?.localization$ | async)?.name }}
		</ng-container>
	</div>
	<div class="md:flex-1 flex justify-between break-all">
		<div class="md:hidden whitespace-pre-line">
			{{ controller.i18n + '.date.text' | translate }}
		</div>
		{{ document.updateTimestamp | userDate: 'LL' | async }}
	</div>
	<div class="md:flex-none md:w-10 flex justify-end space-x-3">
		<ng-content></ng-content>
	</div>
</ng-container>
